import React from 'react';
import DocLink from './DocLink.js';
import SendsTrackComponent from 'components/track/SendsTrackComponent.js';

export default (props) => {
    return (
        <div>
          <p>
            Sends are parallel channels, into which, you can feed audio signal, from any track.
          </p>
          <p>
            Your project's sends are shown below the last track. It looks like this:
          </p>

          <SendsTrackComponent sequencerEngine={props.sequencerEngine}/>
          <p>
            By default, <b>Send A</b> is set to <b>Convolver Reverb</b> and <b>Send B</b> is set to Delay. You can set the effects chain yourself to any combination you want.
          </p>
          <p>
            Click the <b>blue</b> button named "New Send" to create a new send. You'll notice that tracks will now contain a new slider corresponding to this send.
          </p>
          <p>
            Sends let you use the same effect across several tracks. Rather than create a new reverb for every track, just send some signal to the reverb send!
          </p>
          <p>
            Hear things get dubby as you use sends more and more.
          </p>
          <p className="sub-header">
            Routing Options
          </p>
          <p>
            You can configure how tracks output their signal, with relation to sends. The following options are allowed:
            <ul>
              <li>
                <b>Master</b>: The default setting outputs signal to the master channel and sends.
              </li>
              <li>
                <b>Sends Only</b>: This setting only outputs signal to the sends. No output goes directly to the master.
              </li>
            </ul>
          </p>
          <p>
            You can access these options by going to the "Audio To" dropdown, which is
            located next to the Sends faders, in the <DocLink name="Effects" goToLink={props.goToLink}/>-view for a track. 
          </p>
        </div>
    );
};
